<template>
  <div class="card">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-3 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6 text-psychology-secondary">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 16v-4"></path>
          <path d="M12 8h.01"></path>
        </svg>
        结果解读指南
      </div>

      <div class="space-y-4">
        <!-- RPI指数范围 -->
        <div>
          <h4 class="font-semibold text-gray-900 mb-2">RPI指数范围</h4>
          <div class="grid grid-cols-2 md:grid-cols-5 gap-2 text-sm">
            <div class="p-2 rounded text-center bg-psychology-success/10 text-psychology-success">
              <div class="font-medium">0-20</div>
              <div class="text-xs">很低</div>
              <div class="text-xs mt-1">自由自在</div>
            </div>
            <div class="p-2 rounded text-center bg-green-100 text-green-700">
              <div class="font-medium">20-40</div>
              <div class="text-xs">偏低</div>
              <div class="text-xs mt-1">松弛有度</div>
            </div>
            <div class="p-2 rounded text-center bg-yellow-100 text-yellow-700">
              <div class="font-medium">40-60</div>
              <div class="text-xs">中等</div>
              <div class="text-xs mt-1">恰到好处</div>
            </div>
            <div class="p-2 rounded text-center bg-orange-100 text-orange-700">
              <div class="font-medium">60-80</div>
              <div class="text-xs">偏高</div>
              <div class="text-xs mt-1">执着深情</div>
            </div>
            <div class="p-2 rounded text-center bg-red-100 text-red-700">
              <div class="font-medium">80-100</div>
              <div class="text-xs">很高</div>
              <div class="text-xs mt-1">爱到极致</div>
            </div>
          </div>
        </div>

        <div class="border-t border-gray-200 my-4"></div>

        <!-- 四个维度 -->
        <div>
          <h4 class="font-semibold text-gray-900 mb-2">四个维度</h4>
          <div class="grid md:grid-cols-2 gap-3 text-sm">
            <div class="p-3 bg-gray-50 rounded">
              <div class="font-medium text-gray-900">控制欲望</div>
              <div class="text-gray-600">对伴侣的控制倾向和监控行为</div>
            </div>
            <div class="p-3 bg-gray-50 rounded">
              <div class="font-medium text-gray-900">嫉妒强度</div>
              <div class="text-gray-600">嫉妒情绪的强度和频率</div>
            </div>
            <div class="p-3 bg-gray-50 rounded">
              <div class="font-medium text-gray-900">情感依赖</div>
              <div class="text-gray-600">对伴侣的情感依赖程度</div>
            </div>
            <div class="p-3 bg-gray-50 rounded">
              <div class="font-medium text-gray-900">关系不安</div>
              <div class="text-gray-600">在关系中的不安全感水平</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultGuide'
}
</script>

